import React from 'react'
import { Button } from 'react-bootstrap'

const CustomButton = ({ name, isLoading, disabled,className, onClick, minWidth, children, variant="primary" }) => {
    return (
        <div>
            <Button className={`custom-btn ${className}`} variant={variant} style={{ minWidth: minWidth}} disabled={disabled} 
                onClick={onClick}>
                {isLoading ? <><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </> : <>{name} {children}</>}
            </Button>
        </div>
    )
}

export default CustomButton